export default "__VITE_ASSET__0vmsK1HV__"